<div class="row">
  <div class="col-12">
    <app-control-wrapper [control]="cityFormControl" [errors]="defaultErrors">
      <label for="city" control-label>{{ "LABELS.CITY" | translate }}</label>
      <input
        class="form-control"
        id="city"
        name="city"
        type="text"
        control-wrapper
        [formControl]="cityFormControl"
        [dropSpecialCharacters]="false"
        [patterns]="CUSTOM_MASK"
        [mask]="'F*'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        [placeholder]="'FORM_PLACEHOLDER.ENTER' | translate"
      />
    </app-control-wrapper>
  </div>

  <div [ngClass]="{ 'col-6': !isHideState, 'col-12': isHideState }">
    <country-dropdown
      [fc]="countryFormControl"
      [fcValue]="countryFormControl?.value"
      [errors]="defaultErrors"
      [isShowRequired]="false"
      [isDesktop]="true"
      [isFilterRestrictedCountries]="true"
      [defaultCountry]="defaultCountry"
      [isDisabled]="isDisabledCountry"
      [isClearable]="false"
      [isFilterOnlyMarineInsurance]="true"
    ></country-dropdown>
  </div>

  <div class="col-6" *ngIf="!isHideState">
    <state-dropdown [countryFc]="countryFormControl" [stateFc]="stateFormControl" [isClearable]="false"></state-dropdown>
  </div>
</div>
